<template>
  <div
    :class="[
      'protocol-container',
      isMobile ? 'mobile' : ''
    ]"
  >
    <div class="protocol">
      <p class="title">出门问问信息共享清单</p>
      <div class="container">
        <table class="table">
          <tr class="tb-title">
            <th>功能类型</th>
            <th>使用目的</th>
            <th>处理方式</th>
            <th>第三方名称</th>
            <th>涉及个人信息</th>
            <th>第三方连接</th>
          </tr>
          <tr>
            <td>数据存储</td>
            <td>在服务器端存储用户数据</td>
            <td>采用UCloud上的mysql、redis等数据存储介质，存储用户信息。</td>
            <td>优刻得科技股份有限公司（UCloud）</td>
            <td>手机号、昵称、头像、文本数据、音频数据、订单记录、会员信息</td>
            <td>
              <a href="https://docs.ucloud.cn/agreement/privacypolicy"
                >https://docs.ucloud.cn/agreement/privacypolicy</a
              >
            </td>
          </tr>
          <tr>
            <td>发送短信</td>
            <td>向用户发送登录短信、抖店订单短信</td>
            <td>调用阿里云的短信服务，向指定手机号发送短信。</td>
            <td>阿里云计算有限公司</td>
            <td>手机号、短信信息</td>
            <td>
              <a
                href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html"
                >http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html</a
              >
            </td>
          </tr>
          <tr>
            <td>微信支付</td>
            <td>完成会员服务、声音商品的购买功能</td>
            <td>
              使用微信提供的支付功能，生成支付二维码，在微信端支付成功后将用户的支付信息返回魔音工坊以完成支付功能。
            </td>
            <td>财付通支付科技有限公司</td>
            <td>订单及具体金额信息</td>
            <td>
              <a href="https://www.tenpay.com/v3/helpcenter/low/privacy.shtml"
                >https://www.tenpay.com/v3/helpcenter/low/privacy.shtml</a
              >
            </td>
          </tr>
          <tr>
            <td>登录推小果</td>
            <td>登录推小果</td>
            <td>
              openId生成策略：mygf-openId（wwid后8位-用户id 经过aes加密后的字符串）
              <br/>
              作用：登录接口使用
            </td>
            <td>重庆推小果传媒科技有限公司</td>
            <td>用户id</td>
            <td>
              <a href="https://xgsj.lizhibj.cn/h5/pagesUser/service/agreement/privacy"
                >https://xgsj.lizhibj.cn/h5/pagesUser/service/agreement/privacy</a
              >
            </td>
          </tr>
          <tr>
            <td>广告推送</td>
            <td>提供商业化效果广告投放资源</td>
            <td>
              嵌入第三方SDK，SDK收集传输个人信息
            </td>
            <td>上海倍孜网络技术有限公司</td>
            <td>设备/网络/系统信息【设备品牌、设备型号、设备时区、设备语言、系统版本、网络类型、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商、传感器信息(例如：重力传感器、加速度传感器、方向传感器、陀螺仪、压力传感器、重力传感器、线性加速度传感器)、掠过手势内容、cpu】、标识符【OAID】、应用信息【开发者应用名、应用版本号、应用包名、运行状态】、使用数据【如产品交互数据、广告数据(如展示、点击、转化广告数据)】、诊断数据【如崩溃数据、性能数据】</td>
            <td>
              <a href="http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy"
                >http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy</a
              >
            </td>
          </tr>
          <tr>
            <td>发送短信</td>
            <td>向用户发送营销、通知类短信</td>
            <td>
              调用创蓝的短信API，从运营商网络向指定手机号发送短信
            </td>
            <td>上海创蓝云智信息科技股份有限公司</td>
            <td>手机号、短信信息</td>
            <td>
              <a href="https://doc.chuanglan.com/document/TAW0HSZD1HU9CEPI"
                >https://doc.chuanglan.com/document/TAW0HSZD1HU9CEPI</a
              >
            </td>
          </tr>
          <tr>
            <td>语音呼叫</td>
            <td>通过语音呼叫，向用户播放营销、通知类音频</td>
            <td>
              调用创蓝的语音呼叫API，从运营商网络向指定号码发起一通呼叫，呼叫被应答后，播放一段指定的音频
            </td>
            <td>上海创蓝云智信息科技股份有限公司</td>
            <td>手机号、电话信息</td>
            <td>
              <a href="https://doc.chuanglan.com/document/TAW0HSZD1HU9CEPI"
                >https://doc.chuanglan.com/document/TAW0HSZD1HU9CEPI</a
              >
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false
    }
  },
  methods: {
    checkIsMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      this.isMobile = flag
    }
  },
  mounted() {
    this.isMobile = this.checkIsMobile
    if (this.isMobile) {
      document.title = '魔音工坊'
    }
  }
}
</script>

<style lang="less" scoped>

.protocol-container {
  font-size: 16px;
  width: 100%;
  height: 100vh;
  overflow: auto;
  background: #fff;
  color: #1f2329 !important;
  .highlight {
    font-weight: 800;
  }

  .protocol {
    min-width: 470px;
    max-width: 790px;
 
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    margin: 40px auto 0;
    background: #fff;
    box-shadow: 0px 0px 11px 0px rgba(63, 95, 150, 0.04);
    .title {
      margin: 36px 0 22px;
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      color: #1f2329;
      padding: 40px;
    }
    .container {
      margin-top: 20px;
      .table {
        width: 100%;
        max-width: 1000px;
        margin: auto;
      }

      .table th:nth-of-type(1) {
        width: 12%;
      }
      .table th:nth-of-type(2) {
        width: 12%;
      }
      .table th:nth-of-type(3) {
        width: 18%;
      }
      .table th:nth-of-type(4) {
        width: 18%;
      }
      .table th:nth-of-type(5) {
        width: 20%;
      }
      .table th:nth-of-type(6) {
        width: 20%;
      }
      .table,
      .table td,
      .table th {
        border: solid 2px #ddd;
        border-collapse: collapse;
        font-size: 16px;
      }

      .table th {
        // background-color: #eee;
        height: 40px;
      }
      .table td {
        padding: 5px;
      }
      a {
        word-wrap: break-word;
        word-break: break-all;
      }
      a,
      a:hover {
        // color: #333;
        text-decoration: underline;
      }
      .third-content {
        max-width: 1000px;
        margin: 10px auto;
      }
      .third-content p {
        font-size: 14px;
      }
      .p-strong {
        font-weight: bold;
        // margin-top: 40px;
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .protocol {
    width: 80%;
  }
}
// @media screen  and (max-width: 1400px){
//   .protocol{
//     width:80%
//   }
// }
@media screen and (max-width: 1279px) {
  .protocol {
    width: 70%;
  }
}
@media screen and (max-width: 900px) {
  .protocol {
    width: calc(100% - 40px);
  }
}
//app环境
.mobile {
  .protocol {
    width: 100%;
    min-width: auto;
    max-width: none;
    border-radius: 4rpx;
    height: auto;
    box-sizing: border-box;
    // padding: 20px;
    margin: 0;
    margin-top: 40rpx;
    background: #fff;
    box-shadow: 0px 0px 11rpx 0rpx rgba(63, 95, 150, 0.04);
    .title {
      margin: 36rpx 0 22rpx;
      text-align: center;
      font-size: 34rpx;
      font-weight: 500;
      color: #1f2329;
      padding: 40rpx;
    }
    .container {
      margin-top: 20rpx;
      .table {
        width: 100%;
        // max-width: 1000px;
        margin: auto;
      }

      .table th:nth-of-type(1) {
        width: 12%;
      }
      .table th:nth-of-type(2) {
        width: 12%;
      }
      .table th:nth-of-type(3) {
        width: 18%;
      }
      .table th:nth-of-type(4) {
        width: 18%;
      }
      .table th:nth-of-type(5) {
        width: 20%;
      }
      .table th:nth-of-type(6) {
        width: 20%;
      }
      .table,
      .table td,
      .table th {
        border: solid 1rpx #ddd;
        border-collapse: collapse;
        font-size: 16px;
      }

      .table th {
        // background-color: #eee;
        height: 40rpx;
      }
      .table td {
        padding: 5rpx;
      }
      a {
        word-wrap: break-word;
        word-break: break-all;
      }
      a,
      a:hover {
        // color: #333;
        text-decoration: underline;
      }
      .third-content {
        // max-width: 1000px;
        margin: 10rpx auto;
      }
      .third-content p {
        font-size: 14px;
      }
      .p-strong {
        font-weight: bold;
        // margin-top: 40px;
      }
    }
  }
}
// //小程序环境
// .mobile {
//   &.minip {
//     .protocol {
//       min-width: auto;
//       max-width: none;
//       margin: 0 auto;
//       width: 100%;
//       .title {
//         font-size: 3.4rem;
//       }
//       .container {
//         font-size: 20px;
//         .table,
//         .table th,
//         .table td {
//           font-size: 1.6rem;
//         }
//         .title {
//           font-size: 2rem;
//         }
//       }
//     }
//   }
// }
</style>
